export default "__VITE_ASSET__81fc82a4__"